import React, { useState } from 'react';
import {AddCategory,UpdateCategory} from '../Services/CategoryService';

const NewProductPage = ({ onClose, category}) => {

  const isEdit = !!category;

  // State for form data
  const [formData, setFormData] = useState({
    name: category?.name || '',
    description: category?.description || '',
    metaTitle: category?.metaTitle || '',
    metaDescription: category?.metaDescription || '',
    metaKeyword: category?.metaKeyword || '',
    publish: category?.publish !== undefined ? category.publish : true,
    parentCategoryId: category?.parentCategoryId || 0,
  });

  const parentCategories = [
    'None',
    'Electronics',
    'Apparel',
    'Home Goods',
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    formData.metaTitle = formData.name;
    formData.metaDescription = formData.description;
    formData.metaKeyword = formData.name;
    console.log('Form Submitted:', formData);
    let res;
    if (isEdit) {
      res = await UpdateCategory(category.id, formData);
    } else {
      res = await AddCategory(formData);
    }
    if (res?.status) {
      handleClose();
    } else {
      alert(`Failed to ${isEdit ? 'update' : 'add'} category. Please try again.`);
    }
  };

  // Correct handleClose
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="add-category-modal">
      <form className="add-category-form" onSubmit={handleSubmit}>
        <div className="header">
          <h2 className="title">{isEdit ? 'Update Category' : "Add Category's"}</h2>

          {/* Close Button */}
          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
          >
            &times;
          </button>
        </div>

        <div className="form-content">
          <div className="form-group">
            <label htmlFor="name">Enter Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Here"
              required
            />
          </div>

          {/* <div className="form-group">
            <label htmlFor="parentCategory">Parent Category</label>
            <select
              id="parentCategory"
              name="parentCategory"
              value={formData.parentCategory}
              onChange={handleChange}
            >
              <option value="" disabled>Select Here</option>
              {parentCategories.map((category) => (
                <option key={category} value={category}>{category}</option>
              ))}
            </select>
          </div> */}

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter Here"
            />
          </div>

          <div className="form-group publish-toggle">
            <label htmlFor="publish">Publish</label>
            <label className="switch">
              <input
                type="checkbox"
                id="publish"
                name="publish"
                checked={formData.publish}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, publish: e.target.checked }))
                }
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="footer">
          <button type="submit" className="submit-btn">
            {isEdit ? 'UPDATE CATEGORY' : 'ADD CATEGORY'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewProductPage;
